<template>
  <v-form>
    <v-container>
      <div style="height: 30px;"></div>

      <v-text-field v-model="warehouseStocktakingDate" label="棚卸期間" prepend-icon="event" readonly></v-text-field>

      <v-card>
        <v-container>
          <v-select
            v-model="selectedWarehouse"
            :items="warehouses"
            label="倉庫選択"
            item-text="warehouseName"
            v-on:change="selectWarehouse()"
            return-object
          ></v-select>
        </v-container>
      </v-card>

      <div style="height: 30px;"></div>

      <v-card v-if="dispWarehouseItems">
        <v-container>
          <v-card-title class="title-highlight">
            {{ selectedWarehouse.warehouseName }}棚卸在庫
          </v-card-title>

          <v-layout row wrap>
            <v-flex xs12 v-if="!existsConfirmItem">
              <v-text-field
                label="ファイル"
                @click="pickFile"
                v-model="fileName"
                prepend-icon="attach_file"
                hint="CSVファイル"
                v-validate="'required'"
              ></v-text-field>
              <input
                type="file"
                ref="file"
                style="display: none"
                accept=".csv, .xls"
                @change="onFileChange($event)"
              />              
              <v-btn block color="success" dark :loading="loading1" @click="fileUpload()">
                <v-icon dark left>cloud_upload</v-icon>アップロード実行
              </v-btn>
            </v-flex>
          </v-layout> 

          <v-layout row wrap>
            <v-flex xs12>
            <v-btn block color="primary" dark @click="downloadCsv()">
              <v-icon dark left>get_app</v-icon>ダウンロード
            </v-btn>
            </v-flex>
          </v-layout> 

          <v-flex xs12 sm12 v-if="existsConfirmItem">
            <v-alert
              :value="true"
              color="warning"
              icon="info"
              outline
              class="font-weight-bold"
              style="text-align: left;"
            >確定済</v-alert>
          </v-flex>

          <div style="height: 30px;"></div>

          <v-layout row wrap align-center>
            <v-flex xs12>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="JANコード検索"
                single-line
                hide-details
                clearable
              ></v-text-field>
            </v-flex>

            <div style="height: 35px;"></div>

            <v-data-table
              id="dt"
              :headers="headers"
              :items="warehouseItems"
              hide-actions
              class="elevation-1"
              style="width: 100%; margin: 15px 0 0;"
              :search="search"
              :customFilter="customFilter"
              :no-data-text="$t('noTableDataAvailable')"
            >
              <tr v-bind:class="{'confirmed-items': existsConfirmItem}"></tr>

              <template v-slot:items="props">
                <td class="text-xs-center px-2">{{ props.item.janCode }}</td>
                <td class="text-xs-left px-2">{{ props.item.itemName }}</td>
                <td class="text-xs-right px-2" v-if="existsConfirmItem" >{{ props.item.stockQuantity }}</td>
                <td class="text-xs-right px-2" v-else @click="editItem(props.item)">
                  <span class="indigo--text"> {{ props.item.stockQuantity }} </span>
                  <!-- <input
                    type="number"
                    name="itemNum[]"
                    v-model="props.item.stockQuantity"
                    class="column-input-for-order"
                    min="0"
                    onfocus="this.value=''"
                    value="0"
                    :disabled="loading || existsConfirmItem"
                  />-->
                </td>
              </template>
            </v-data-table>

            <v-dialog v-model="updateDialog" max-width="500px">
              <v-card>
                <v-container>
                  <v-card-title>在庫入力</v-card-title>

                  <!-- <v-card-text> -->
                  <v-container grid-list-md>
                    <v-layout row warp>
                      <p class="font-weight-bold text-xs-left">商品名: {{ this.editedItem.itemName }}</p>
                    </v-layout>
                    <v-layout row warp align-content-center>
                      <p class="font-weight-bold">1段ボールへの入数: {{ this.editedItem.quantityInBox }}入</p>
                    </v-layout>
                    <div style="height: 10px;"></div>
                    <v-divider></v-divider>
                    <v-layout row wrap justify-space-between align-center>
                      <v-flex xs5 sm5>
                        <v-text-field
                          v-model="editedItem.quantityOfBox"
                          value="0"
                          label="BOX数"
                          type="number"
                          min="0"
                          v-if="editedItem.quantityInBox != 0"
                          @click="editedItem.quantityOfBox = ''"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs5 sm5>
                        <v-text-field
                          v-model="editedItem.stockQuantity"
                          value="0"
                          label="個数"
                          type="number"
                          min="0"
                          @click="editedItem.stockQuantity = ''"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-divider></v-divider>
                    <div style="height: 10px;"></div>
                    <v-layout row warp reverse>
                      <v-flex xs5 sm5>
                        <v-text-field
                          class="font-weight-bold"
                          reverse
                          label="総個数"
                          box
                          readonly
                          :value="
                            editedItem.quantityInBox *
                              editedItem.quantityOfBox +
                              Number(editedItem.stockQuantity)
                          "
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                  <!-- </v-card-text> -->

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="close">
                      <v-icon dark>arrow_back</v-icon>戻る
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      flat
                      @click="updateStockByUser()"
                      :loading="updateLoading"
                    >
                      <v-icon dark>save</v-icon>更新
                    </v-btn>
                  </v-card-actions>
                </v-container>
              </v-card>
            </v-dialog>

            <v-flex xs12 sm12>
              <div style="height: 30px;"></div>
            </v-flex>

            <v-flex xs12 sm12>
              <v-textarea
                outline
                v-model="remarks"
                counter="1000"
                :label="$t('sales.order-remarks')"
                clearable
                v-if="!existsConfirmItem"
              ></v-textarea>
            </v-flex>

            <v-flex xs12 sm12 v-if="existsConfirmItem">
              <v-textarea
                v-for="item in dispRemarksList"
                :key="item.title"
                outline
                :label="item.userName + 'さんの追伸'"
                disabled
                :value="item.remarks"
              ></v-textarea>
            </v-flex>

            <v-flex xs12 sm12>
              <div style="height: 25px;"></div>
            </v-flex>

            <!-- 버튼 영역 -->
            <div class="footer-btns">
              <v-btn
                align-center
                block
                color="success"
                dark
                :disabled="existsConfirmItem"
                @click="saveItems()"
              >一時保存する
              </v-btn>
              <v-btn
                block
                color="warning"
                dark
                :disabled="existsConfirmItem"
                @click="forwardConfirm()"
              >確定する
              </v-btn>
            </div>
          </v-layout>
        </v-container>
        <!-- <v-fab-transition>
          <v-btn
            v-model="fab"
            color="success"
            dark
            fab
            fixed
            bottom
            right
            :disabled="existsConfirmItem"
            @click="saveItems()"
          >
            <v-icon>save</v-icon>
          </v-btn>
        </v-fab-transition>-->
      </v-card>

      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-btn block color="#4C728A" dark :to="{ name: 'admin/new-admin-menu' }">
            <v-icon color="black" left>home</v-icon>Home
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import { mapState } from 'vuex'
import ServerApiCallService from '@/services/ServerApiCallService.js'
import moment from 'moment-timezone'
import axios from 'axios'

export default {
  created() {
    console.log('created')

    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)

    var nowWeekNumber = moment().week()
    this.warehouseStocktakingDate =
      moment()
        .startOf('week')
        .week(nowWeekNumber)
        .format('MM/DD') +
      ' - ' +
      moment()
        .endOf('week')
        .week(nowWeekNumber)
        .format('MM/DD')
        
    // 1. 倉庫データの取得
    this.getWarehouseInfo()
  },
  computed: {
    ...mapState({
      user: state => state.user,
      selectedStore: state => state.salesSession.menuSelectedStore
    })
  },
  methods: {
    getWarehouseInfo() {
      console.log('getWarehouseInfo')
      let thisObj = this

      ServerApiCallService.warehouseInfo()
        .then(response => {
          this.warehouses = response.data.warehouses

          // 倉庫のステータスが無効の場合、表示しない
          this.warehouses.forEach(function(row, index) {
            if (row.isDeleted === '1') {
              thisObj.warehouses.splice(index, 1)
            }
          })

          this.warehouses.sort(function(a, b) {
            if (a.warehouseId > b.warehouseId) return 1
            if (a.warehouseId < b.warehouseId) return -1
            // a must be equal to b
            return 0
          })
        })
        .catch(error => {
          console.log('There was an error(getWarehouseInfo):', error.response)
        })
    },
    selectWarehouse() {
      console.log('selectWarehouse')
      this.dispWarehouseItems = true
      this.getWarehouseItems()
    },
    customFilter(items, search) {
      console.log('custom filter')

      if (!search) {
        return items
      } else {
        let filteringItems = items.filter(function(value) {
          if (value.janCode.includes(search)) {
            return true
          } else {
            return false
          }
        })
        return filteringItems
      }
    },
    getWarehouseItems() {
      console.log('getWarehouseItems')

      let request = {
        warehouseId: this.selectedWarehouse.warehouseId,
        weekNumber: moment().week(),
        stocktakingYear: moment().format('YYYY')
      }

      ServerApiCallService.warehouseItems(request)
        .then(response => {
          this.existsConfirmItem = response.data.existsConfirmItem
          this.warehouseItems = response.data.items
          this.remarks = response.data.remarks
          var userData = []
          
          if (this.existsConfirmItem) {
            userData = response.data.confirmItems
          } else {
            userData = response.data.itemsByUserId
          }

          if (userData) {
            // 保存されているユーザーデータがある場合、取り込む処理
            this.warehouseItems.forEach(function(row) {
              userData.forEach(function(userDataRow) {
                if (row.itemCode == userDataRow.itemCode) {
                  row.stockQuantity = userDataRow.stockQuantity
                  if (userDataRow.warehouseStockTempId) {
                    row.warehouseStockTempId = userDataRow.warehouseStockTempId
                  }
                }
              })
            })
          }

          // 商品の表示順 商品カテゴリ、商品名
          this.warehouseItems.sort(function(a, b) {
            if (a.itemName > b.itemName) return 1
            if (a.itemName < b.itemName) return -1
            // a must be equal to b
            return 0
          })
          this.warehouseItems.sort(function(a, b) {
            if (a.itemCategoryId > b.itemCategoryId) return 1
            if (a.itemCategoryId < b.itemCategoryId) return -1
            // a must be equal to b
            return 0
          })
        })
        .catch(error => {
          console.log('There was an error(getWarehouseItems):', error.response)
        })
    },
    saveItems() {
      console.log('saveItems')
      this.loading = true

      let request = {
        stocktakingYear: moment().format('YYYY'),
        warehouseId: this.selectedWarehouse.warehouseId,
        weekNumber: moment().week(),
        // warehouseItems: this.warehouseItems.filter(
        //   item => item.stockQuantity > 0
        // ),
        remarks: this.remarks
      }

      ServerApiCallService.saveStockByUser(request)
        .then(response => {
          this.getWarehouseItems()
          this.loading = false
        })
        .catch(error => {})
    },
    forwardConfirm() {
      console.log('forward confirm')

      this.$router.push({
        name: 'admin/WarehouseStocktakingConfirm',
        params: { selectedWarehouse: this.selectedWarehouse }
      })
    },
    editItem(item) {
      console.log('editItem')

      // 過去のデータの場合、編集不可
      // var now = moment().format('YYYYMM')
      // var selectedMonth = moment(this.stocktakingMonth, 'YYYY-MM-DD').format(
      //   'YYYYMM'
      // )
      // if (now > selectedMonth) return

      item.quantityOfBox = 0

      this.editedItem = Object.assign({}, item)
      this.editedItem.quantityOfBox = 0
      this.updateDialog = true
    },
    close() {
      this.updateDialog = false
    },
    updateStockByUser() {
      console.log('updateStockByUser')

      this.updateLoading = true

      let request = {
        stocktakingYear: moment().format('YYYY'),
        warehouseId: this.selectedWarehouse.warehouseId,
        weekNumber: moment().week(),
        warehouseStockTempId: this.editedItem.warehouseStockTempId,
        itemCode: this.editedItem.itemCode,
        stockQuantity:
          this.editedItem.quantityInBox * this.editedItem.quantityOfBox +
          Number(this.editedItem.stockQuantity)
      }

      ServerApiCallService.updateStockByUser(request)
        .then(response => {
          this.getWarehouseItems()
          this.updateLoading = false
        })
        .catch(error => {
          this.updateLoading = false
        })
      this.updateDialog = false
      this.getWarehouseInfo()
    },
    downloadCsv() {
      let request = {
        warehouseId: this.selectedWarehouse.warehouseId,
        weekNumber: moment().week(),
        stocktakingYear: moment().format('YYYY')
      }

      axios
        .create({
          baseURL: ServerApiCallService.getServerUrl(),
          withCredentials: false,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json;charset=utf-8',
            accessToken: window.localStorage.getItem('accessToken')
          }
        })
        .post('/admin/warehouse-stock-download', request, {
          responseType: 'blob',
        })
        .then(({ data }) => {
          let blob = new Blob([data], { type: 'text/csv' })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = this.selectedWarehouse.warehouseName + '_在庫棚卸.csv'
          link.click()
        })
    },
    pickFile() {
      this.$refs.file.click()
    },
    onFileChange(e) {
      // const files = e.target.files
      this.targetFile = e.target.files[0]

      if (this.targetFile !== undefined) {
        this.fileName = this.targetFile.name
      }
    },
    fileUpload() {
      console.log('fileUpload')
      let thisObj = this
      
      // FormData を利用して File を POST する
      let formData = new FormData()
      formData.append('uploadFile', this.targetFile)
      formData.append('charsetName', this.fileFormat)
      formData.append('warehouseId', this.selectedWarehouse.warehouseId)
      formData.append('weekNumber', moment().week())
      formData.append('stocktakingYear', moment().format('YYYY'))

      let sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent
      }

      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$parent.$parent.$parent.showErrorDialog(this.$t('hasInputError'))
          return
        }
      })

      thisObj.loading1 = true      
      ServerApiCallService.sendWarehouseStockFile(formData, sendContext)
        .then(response => {
          // 버튼의 빙글빙글 돌게 하는거
          thisObj.loading1 = false
          // 초기화면
          this.dispWarehouseItems = true
          this.getWarehouseItems()
        })
        .catch(error => {
          thisObj.loading1 = false
        })
    },
  },
  data() {
    return {
      loading1: false,
      fileName: '',
      fileFormat: 'SHIFT-JIS',
      updateLoading: false,
      quantityOfBox: 0,
      editedItem: [],
      updateDialog: false,
      remarks: '',
      dispRemarksList: [],
      warehouseStocktakingDate: '',
      warehouses: [],
      loading: false,
      menu2: false,
      shippingDate: '',
      shippingDateForPicker: '',
      dispWarehouseItems: false,
      selectedWarehouse: [],
      fab: '',
      search: '',
      warehouseItems: [],
      dialog: false,
      existsConfirmItem: false,
      headers: [
        {
          text: 'No',
          align: 'left',
          value: 'itemCode',
          width: '5%',
          sortable: false,
          fixed: false,
          class: 'px-2'
        },
        {
          text: this.$t('sales.product-name'),
          align: 'left',
          value: 'itemName',
          width: '80%',
          sortable: false,
          fixed: false,
          class: 'px-2'
        },
        {
          text: '物理在庫数',
          align: 'right',
          sortable: false,
          value: 'stocks',
          width: '15%',
          fixed: true,
          class: 'px-2'
        }
      ]
    }
  }
}
</script>

<style>
.confirmed-items {
  background-color: #adadad;
}
#dt tr:nth-child(even) {
  background-color: #f2f2f2;
}
.title-highlight {
  font-size: 20px;          /* 🔹 기본 타이틀보다 크게 */
  font-weight: bold;        /* 🔹 굵게 */
  color: #2c3e50;           /* 🔹 진한 남색 계열 */
  /*border-left: 5px solid #4C728A; /* 🔹 왼쪽에 포인트 라인 */
  padding-left: 10px;       /* 🔹 라인과 글자 사이 간격 */
  margin-bottom: 10px;      /* 🔹 아래 여백 */
}
.footer-btns {
  position: sticky;         /* 스크롤해도 하단 고정 */
  bottom: 0;                /* 컨테이너의 맨 아래 */
  display: flex;
  justify-content: space-between; /* 버튼 사이 일정 간격 */
  gap: 8px;                 /* 버튼들 사이 여백 */
  width: 100%;              /* 테이블 폭과 동일 */
  background: white;        /* 버튼 뒤 배경 */
  padding: 10px 0;          /* 위아래 여백 */
  z-index: 1000;
}
.footer-btns .v-btn {
  flex: 1;                  /* 버튼들이 같은 폭 */
}
</style>
